// @flow
import React, { Component } from 'react';
import PulsingCircle from '@localytics/loc-components/lib/PulsingCircle';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { get as _get } from 'lodash';
import {
  isEditable,
  hasActiveVersion,
  type OrchestrationVersion,
  type Creative
} from '../constants/ApiTypes';
import type { EventMapping, AppGroup, App } from '../constants/RailsApiTypes';
import type { VersionConfig } from '../constants/ApiTypes';
import {
  addNode,
  getOrchestrationVersion,
  getOrchestrationVersions,
  getOrchestrationVersionCreatives
} from '../actions/api';
import { getAppGroups } from '../actions/rails-api';
import { clearTree } from '../actions/tree';
import CampaignNameHeader from './CampaignNameHeader';
import AppGroupHeader from './AppGroupHeader';
import EntryEventHeader, { LineBreak } from './EntryEventHeader';
import Tree from './Tree';
import GettingStarted from './GettingStarted';
import { getQueryParams } from '../util/RouterUtils';

type Props = {
  appGroupName: string,
  entryEvent: Object,
  addNode: Function,
  entryEvent: EventMapping,
  editable: boolean,
  reEntryLimit: VersionConfig | null,
  orchestrationId: number,
  versionId: number,
  orgId: number,
  nodesList: Array<any>,
  linksList: Array<any>,
  selectedNode: number,
  appGroups: Array<any>,
  getOrchestrationVersions: Function,
  getOrchestrationVersion: Function,
  getOrchestrationVersionCreatives: Function,
  clearTree: Function,
  getAppGroups: Function,
  commonData: {
    eventMappings: Array<EventMapping>,
    eventMappingsById: { [number]: EventMapping },
    appGroups: Array<AppGroup>,
    appGroupsById: { [number]: AppGroup },
    creatives: Array<Creative>
  },
  creative: {
    form: Object,
    keyValues: Object
  },
  version: OrchestrationVersion,
  versionApps: Array<App>,
  authReady: boolean,
  orchHasActiveVersion: boolean
};

type State = {
  loaded: boolean
};

class Flowbuilder extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      loaded: false
    };
  }

  componentDidMount() {
    if (this.props.authReady && !this.state.loaded) {
      this.loadData();
    }
  }

  // getDerivedStateFromProps(nextProps, prevState) { // TODO: Use this in next version of React
  // TODO: Try to be more sophisticated about what's loaded, and provide a better "loading" experience
  componentWillReceiveProps(nextProps) {
    if (nextProps.authReady && !this.state.loaded) {
      this.loadData();
    }
  }

  componentWillUnmount() {
    this.props.clearTree();
  }

  loadData() {
    this.setState({ loaded: true });
    this.props.getOrchestrationVersion(
      this.props.orgId,
      this.props.orchestrationId,
      this.props.versionId
    );
    this.props.getOrchestrationVersions(
      this.props.orgId,
      this.props.orchestrationId
    );
    this.props.getOrchestrationVersionCreatives(
      this.props.orgId,
      this.props.orchestrationId,
      this.props.versionId
    );
    this.props.getAppGroups(this.props.orgId);
  }

  render() {
    const {
      orchestrationId,
      versionId,
      orgId,
      appGroupName,
      version,
      entryEvent,
      reEntryLimit,
      nodesList,
      linksList,
      creative,
      commonData,
      selectedNode,
      orchHasActiveVersion,
      versionApps
    } = this.props;
    if (!this.state.loaded) {
      return <PulsingCircle />;
    }
    const { name: entryEventName } = entryEvent || {};
    const currentIds = { orchestrationId, versionId, orgId };
    const editable = isEditable(version);
    return (
      <div className="Page__Body">
        <CampaignNameHeader
          editable={editable && !orchHasActiveVersion}
          {...currentIds}
        />
        <div className="Page__Subheader">
          <AppGroupHeader
            editable={editable}
            appGroupName={appGroupName}
            apps={versionApps}
            version={version}
          />
          <LineBreak />
          <EntryEventHeader
            editable={editable}
            orchHasActiveVersion={orchHasActiveVersion}
            entryEvent={entryEvent}
            reEntryLimit={reEntryLimit}
            version={version}
          />
        </div>
        <div className="Page__Content">
          <GettingStarted entryEventName={entryEventName} />
          <Tree
            nodesList={nodesList}
            linksList={linksList}
            creativeData={creative}
            commonData={commonData}
            selectedNode={selectedNode}
            addNode={this.props.addNode}
            editable={editable}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { orgId, orchestrationId, versionId } = getQueryParams(
    ownProps.location
  );
  const { authReady } = state.api;
  const {
    [orchestrationId]: versions = {}
  } = state.api.versionsByOrchestrationId;
  const { [versionId]: version = {} } = versions;
  const {
    [orchestrationId]: orchestration = {}
  } = state.api.orchestrationsById;
  const commonData = state.railsApi;
  const entryEvent =
    commonData.eventMappingsById &&
    version.nodes &&
    version.nodes[1] &&
    version.nodes[1].event_mapping_id &&
    commonData
      ? commonData.eventMappingsById[+version.nodes[1].event_mapping_id]
      : commonData.eventMappings[0];
  const reEntryLimit = orchestration.config ? orchestration.config : null;
  const appGroupName = _get(
    commonData,
    `appGroupsById.${version.app_group_id}.name`,
    ''
  );
  const orchHasActiveVersion = hasActiveVersion(
    Object.keys(versions).map(key => versions[key])
  );

  const { apps: versionApps = [] } = version;
  const { apps: allApps = {} } = commonData;
  return {
    orchestrationId,
    versionId,
    orgId,
    orchestration,
    creative: state.creative,
    entryEvent,
    reEntryLimit,
    appGroupName,
    nodesList: state.tree.nodesList,
    linksList: state.tree.linksList,
    selectedNode: state.tree.selectedNode,
    version,
    orchHasActiveVersion,
    authReady,
    versionApps: versionApps.map(app => allApps[app.app_uuid])
  };
};

const mapDispatchToProps = {
  addNode,
  getOrchestrationVersions,
  getOrchestrationVersion,
  getOrchestrationVersionCreatives,
  getAppGroups,
  clearTree
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Flowbuilder)
);



// WEBPACK FOOTER //
// ./src/components/Flowbuilder.jsx